import React from 'react';

import {Col, Button} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from "@fortawesome/pro-solid-svg-icons";

import styles from './selected-item-widget.module.scss';


const SelectedItemWidget = (props) => {
    
    const {children, onSelect} = props;

    const removeSelectHandler = () => {
        onSelect(null);
    }

    return (
            <Col>
                <Button onClick={removeSelectHandler} type="link" danger className={styles.removerSelecao}>
                    <FontAwesomeIcon  icon={faTimes}></FontAwesomeIcon>
                </Button>
                <div className={styles.content}>
                    {children}

                </div>
            </Col>
    );
    
}

export { SelectedItemWidget }